import { Component, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { catchError, from, of, tap } from 'rxjs';

@Component({
    selector: 'traces',
    templateUrl: 'traces.component.html',
    styleUrls: ['traces.component.scss'],
})
export class TracesComponent {
    @Input() public scroll = false;
    @Input() public docId = '';    
    public allTraces = [];
    public filteredTraces = [];
    public traces;
    public trace: boolean = true;
    public libTrace: string;
    public skeleton: boolean = true;
    public error: boolean = false;

    constructor(private translate: TranslateService, private api: ApiV6Service, protected _messageService: MessagesService) {
    }

    public ngOnInit() {
        this.initialize();
    }

    public ngOnChanges() {
        this.initialize();
        this.returnData();
        this.swithTrace();
    }      

    private initialize() {
        this.trace = false;
        this.skeleton = true;
        this.error = false;
    }

    private returnData() {
        if (this.docId !== '') {
            return from(this.api.getTraceDoc(this.docId)).pipe(
                tap(result => {
                    this.traces = [...(result?.['TraceList']?.['Trace'] || [])];
                    this.allTraces = this.traces;
                    this.filteredTraces = this.getFilteredTraces(this.allTraces);
                    this.skeleton = false;
                    this.error = false;
                    this.swithTrace();
                }),
                catchError((error: any) => {
                    console.log(error);
                    this.error = true;
                    this.skeleton = true;
                    this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
                    return of(null); // Émet une valeur par défaut en cas d'erreur
                })
            ).subscribe();
        }
    }

    public async refresh() {
        this.initialize();
        await this.returnData();
    }

    private getFilteredTraces(aList) {
        return aList.filter((item) => {
            return this.verifyType(item);
        });
    }
    
    private verifyType(aItem) {
        if (
            aItem.Type === '13001' ||
            aItem.Type === '13002' ||
            aItem.Type === '13003' ||
            aItem.Type === '13004' ||
            aItem.Type === '13005' ||
            aItem.Type === '13006' ||
            aItem.Type === '13007' ||
            aItem.Type === '13008' ||
            aItem.Type === '13009' ||
            aItem.Type === '13010' ||
            aItem.Type === '13013' ||
            aItem.Type === '13014' ||
            aItem.Type === '13018' ||
            aItem.Type === '13021' ||
            aItem.Type === '13022' ||
            aItem.Type === '13023' ||
            aItem.Type === '13024' ||
            aItem.Type === '13025'
        ) {
            return false;
        } else {
            return true;
        }
    }

    public swithTrace() {
        if (this.trace === true) {
            this.libTrace = this.translate.instant('Trace_M');
            this.trace = false;
            this.traces = this.filteredTraces;
        } else {
            this.libTrace =  this.translate.instant('Trace');
            this.trace = true;
            this.traces = this.allTraces;
        }
    }
}